<template>
  <div
    class="rounded-xl transition-all duration-300 ease-in-out cursor-pointer relative overflow-hidden bg-cover bg-center bg-no-repeat"
    :class="[isExpanded ? 'col-span-2 -translate-y-14' : 'col-span-1', isExpanded ? 'shadow-lg' : 'shadow-md']"
    :style="{ backgroundImage: `url('/relax_and_recharge_${(index % 5) + 1}.jpg')` }"
    @mouseenter="$emit('mouseenter', index)"
    @mouseleave="$emit('mouseleave')"
  >
    <!-- Gradient overlay - darker when not hovered, lighter when hovered -->
    <div 
      class="absolute inset-0 bg-gradient-to-t transition-all duration-300"
      :class="isExpanded ? 'from-black/70 via-black/30 to-transparent' : 'from-black/90 via-black/60 to-transparent'"
    />

    <!-- Text content that appears when expanded -->
    <div v-if="isExpanded" class="absolute inset-0 flex items-end justify-center text-white p-6 md:p-10 z-10">
      <div class="text-left">
        <h3 class="heading-2 mb-2">{{ galleryTitles[index] }}</h3>
        <p class="body-2 opacity-90">{{ galleryDescriptions[index] }}</p>
      </div>
    </div>
    <slot />
  </div>
</template>

<script setup lang="ts">
interface Props {
  index: number
  isExpanded: boolean
}

interface Emits {
  (e: 'mouseenter', index: number): void
  (e: 'mouseleave'): void
}

const props = defineProps<Props>()
defineEmits<Emits>()

const galleryTitles = [
  'Gear & Souvenirs',
  'Welcome Reception',
  'Culinary Mastery',
  'Dining Experience',
  'Coffee Corner'
]

const galleryDescriptions = [
  'Get ready for your ATV and rafting adventure with our quality gear, shirts, and sandals store.',
  'Meet our friendly receptionist who will help you plan your exciting outdoor activities and adventures.',
  'Fuel up for your adventure with delicious meals prepared by our skilled chef before your activities.',
  'Enjoy a satisfying meal served by our attentive waitress after your thrilling ATV and rafting experience.',
  'Recharge with a refreshing drink from our barista while sharing stories of your exciting adventures.'
]
</script>
